import { render } from "./CounterProposal.vue?vue&type=template&id=23a4a3b8&scoped=true"
import script from "./CounterProposal.vue?vue&type=script&lang=ts"
export * from "./CounterProposal.vue?vue&type=script&lang=ts"

import "./CounterProposal.vue?vue&type=style&index=0&id=23a4a3b8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-23a4a3b8"

export default script